<ng-content select="contingent-ui-search-card-input-container"></ng-content>
<ng-content select="contingent-ui-search-card-results"></ng-content>
